import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class ServiceUnavailableError extends EluveError {
  static override readonly errorName = 'ServiceUnavailableError';
  readonly logLevel: LogLevel = 'error';

  constructor(
    message = 'Service is temporarily unavailable',
    args?: EluveErrorArgs,
  ) {
    super(message, args);
  }
}
